/**
 * Tiny dev-only logger.
 *
 * Use this instead of `console.log` / `console.error` for diagnostic output.
 * In production builds (CRA sets `process.env.NODE_ENV === 'production'` at
 * build time and dead-strips the `if` branch), these become no-ops.
 *
 * Real errors that should reach an error monitor (Sentry, Datadog) should
 * call `reportError(...)` and route through that integration rather than
 * `console.error`.
 */

const isDev = process.env.NODE_ENV !== 'production';

export const log = (...args: unknown[]): void => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

export const warn = (...args: unknown[]): void => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};

export const logError = (...args: unknown[]): void => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};
